// Vendor
import * as React from 'react';

// Bernie
import { ClickTracker } from 'bernie-analytics';
import { LocalizedText } from 'bernie-l10n';

// UITK
import { UitkTertiaryButton } from 'uitk-react-button';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';

const TrackedButton = ClickTracker(UitkTertiaryButton);

export interface AdditionalInfoProps {
  collapsedLinkName: string;
  collapsedMsgKey: string;
  collapsedRfrr: string;
  displayHeaderText: boolean;
  expandedLinkName: string;
  expandedMsgKey: string;
  expandedRfrr: string;
  headerTextKey: string;
  keepOpen: boolean;
}

export const AdditionalInfo: React.FunctionComponent<AdditionalInfoProps> = props => {
  const {
    children,
    collapsedLinkName,
    collapsedMsgKey,
    collapsedRfrr,
    displayHeaderText,
    expandedLinkName,
    expandedMsgKey,
    expandedRfrr,
    headerTextKey,
    keepOpen,
  } = props;

  const [isExpanded, setExpanded] = React.useState(keepOpen);

  const handleToggle = (): void => {
    if (!keepOpen) {
      setExpanded(!isExpanded);
    }
  };

  const expandMessage = isExpanded ? expandedMsgKey : collapsedMsgKey;
  const iconName = isExpanded ? 'expand_less' : 'expand_more';
  const rfrr = isExpanded ? expandedRfrr : collapsedRfrr;
  const linkName = isExpanded ? expandedLinkName : collapsedLinkName;

  return (
    <div className="uitk-card-separator-top uitk-grid">
      {!displayHeaderText && (
        <TrackedButton className="uitk-grid" onClick={handleToggle} linkName={linkName} rfrr={rfrr}>
          <span className="uitk-cell all-cell-fill uitk-type-left uitk-type-300">
            <LocalizedText message={expandMessage} />
          </span>
          <UitkIcon name={iconName} size={UitkIconSize.SMALL} />
        </TrackedButton>
      )}
      {displayHeaderText && (
        <h3 className="all-x-padding-three all-y-padding-two">
          <LocalizedText message={headerTextKey} />
        </h3>
      )}

      {isExpanded && <ul className="uitk-grid no-bullet">{children}</ul>}
    </div>
  );
};
AdditionalInfo.displayName = 'AdditionalInfo';

export interface AdditionalInfoListItemProps {
  key: string;
}

export const AdditionalInfoListItem: React.FunctionComponent<AdditionalInfoListItemProps> = ({ children, key }) => (
  <li className="uitk-cell l-cell-1-3 xl-cell-1-3 all-x-padding-three all-y-padding-two" key={key}>
    {children}
  </li>
);
AdditionalInfoListItem.displayName = 'AdditionalInfoListItem';
